import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';
import { downloadEmployees } from '../lib/employees';

export const useDownloadEmployees = () => {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: downloadEmployees,
    onError: (error: ApiError) => {
      toast.error(
        error?.response?.data?.message ||
          t('common:errorMessages.somethingWentWrong'),
      );
    },
  });
};
